// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

function isSome(x) {
  if (x) {
    return /* true */1;
  } else {
    return /* false */0;
  }
}

function map(fn, x) {
  if (x) {
    return /* Some */[Curry._1(fn, x[0])];
  } else {
    return /* None */0;
  }
}

function withDefault($$default, x) {
  if (x) {
    return x[0];
  } else {
    return $$default;
  }
}

function run(fn, x) {
  if (x) {
    Curry._1(fn, x[0]);
    return /* () */0;
  } else {
    return /* () */0;
  }
}

exports.isSome      = isSome;
exports.map         = map;
exports.withDefault = withDefault;
exports.run         = run;
/* No side effect */



//////////////////
// WEBPACK FOOTER
// ./src/Option.re
// module id = 15
// module chunks = 0